
import ProductItem from './ProductItem';
import * as React from 'react';

import { ISeedProduct } from '../../../../../infrastructure/interfaces';

interface SeedCategory {
    category: string;
    seeds: ISeedProduct[];
}

interface SeedCategoryAccordionProps {
    categories: SeedCategory[];
    open: boolean;
}
export class SeedCategoryAccordion extends React.Component<SeedCategoryAccordionProps, { open: boolean }> {
  constructor(props: SeedCategoryAccordionProps) {
    super(props);
    this.state = { open: this.props.open, };
  }

  onToggle = (e: any) => {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }
  render() {
    const { open } = this.state;

    const className = `drop-item-link ${open ? ' active' : ''}`;
    return (
      <div className="drop-item">
        <span onClick={this.onToggle} className={className}>
          <i className="fa fa-caret-right" aria-hidden="true"></i>
            Seeds
        </span>
        {open && this.props.categories.map((c) => (
          <SeedAccordion 
            key={c.category} 
            category={c.category} 
            seeds={c.seeds}
            open={open}
          />))}
      </div>
    );
  }
}

export class SeedAccordion extends React.Component<SeedCategory & { open: boolean }, { open: boolean }> {
  constructor(props: SeedCategory & { open: boolean }) {
    super(props);
    this.state = { open: props.open, };
  }

  onToggle = (e: any) => {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }
  render() {
    const { open } = this.state;

    const className = `drop-item-link drop-item-link-seed ${open ? ' active' : ''}`;
    return (
      <div className="drop-item">
        <span onClick={this.onToggle} className={className}>
          <i className="fa fa-caret-right" aria-hidden="true"></i>
          {this.props.category}
        </span>
        { open && this.props.seeds.map(seed => 
          <ProductItem
            product={seed}
            type={'item'}
            key={seed.name} 
            className="product-list-item product-list-item-seed"
          />)
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ProductTab/SeedCategoryAccordion.tsx